import { render, staticRenderFns } from "./SmartIdChallengeIdModal.vue?vue&type=template&id=4de058f8"
import script from "./SmartIdChallengeIdModal.vue?vue&type=script&lang=js"
export * from "./SmartIdChallengeIdModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports